<template>
  <div class="fixed inset-0 z-40 overflow-y-auto">
    <transition name="fade" appear>
      <div
        class="bg-ontick-carbon-900 fixed inset-0 bg-opacity-75 backdrop-blur-sm backdrop-filter"
      ></div>
    </transition>
    <button
      class="fixed inset-0 cursor-default"
      @click.self="$emit('close')"
    ></button>

    <div
      class="pointer-events-none fixed inset-0 flex items-center justify-center"
    >
      <transition name="fade" appear>
        <div
          class="bg-ontick-carbon-500 pointer-events-auto relative w-[440px] rounded-[32px] p-6"
        >
          <div class="flex flex-col gap-4">
            <div class="flex items-center justify-between">
              <p class="text-xl font-bold">
                {{ data.best_data.label }}
              </p>
              <button
                class="bg-ontick-graphite-500 flex h-10 w-10 items-center justify-center rounded-full transition-all hover:brightness-125"
                @click="$emit('close')"
              >
                <i v-html="$icons.closex" class="text-gray-50"></i>
                <span class="sr-only"> Fechar </span>
              </button>
            </div>
            <div
              class="bg-ontick-graphite-500 flex flex-col gap-1 rounded-2xl px-4 py-8"
            >
              <dl>
                <dt>Multiplicador</dt>
                <dd>{{ data.selected_multiplier }}x</dd>
              </dl>
              <dl>
                <dt>Objetivo</dt>
                <dd>{{ data.selected_target }}{{ targetType }}</dd>
              </dl>
              <dl>
                <dt>Direção</dt>
                <dd class="text-ontick-yellow-700">
                  {{ data.type == "buy" ? "Compra" : "Venda" }}
                </dd>
              </dl>
              <dl>
                <dt>Ganho</dt>
                <dd class="text-ontick-green-600">
                  {{ data.pnl | currency }}
                </dd>
              </dl>
              <dl>
                <dt>Perda</dt>
                <dd class="text-ontick-red-600">
                  {{ (data.pnl * -1) | currency }}
                </dd>
              </dl>
              <dl>
                <dt>Custo da operação</dt>
                <dd>
                  {{
                    (data.best_data.best_cost * data.selected_multiplier)
                      | currency
                  }}
                </dd>
              </dl>
            </div>
            <p class="text-ontick-yellow-700">
              Atenção: o saldo em conta necessário para este Best é de
              <span class="whitespace-nowrap">
                {{
                  (data.best_data.best_margin * data.selected_multiplier)
                    | currency
                }}.
              </span>
            </p>
            <button
              :disabled="button_is_disabled"
              class="flex items-center justify-center rounded-full border-2 py-2 text-[32px] font-extrabold transition-all hover:brightness-125 disabled:cursor-not-allowed disabled:contrast-0"
              :class="[
                { 'buy-call': type.toLowerCase() == 'buy' },
                { 'sell-call': type.toLowerCase() == 'sell' },
              ]"
              @click="start(data)"
            >
              <span class="best-shadow text-gray-50"> Best! </span>
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import startBest from "../start-best";
export default {
  mixins: [startBest],

  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      show_bg: false,
    };
  },

  methods: {},

  computed: {
    type() {
      return this.data.type;
    },
    targetType() {
      switch (this.data.best_data.best_target_type) {
        case "POINTS":
          return "p";
        default:
          return "%";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
dl {
  @apply flex w-full items-center justify-between;
  dd {
    @apply text-right font-semibold;
  }
}
.best-shadow {
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 1);
}
.buy-call {
  @apply border-ontick-green-400 backdrop-blur-lg backdrop-filter;
  background: linear-gradient(
    to bottom right,
    #0c6941,
    #0c6941 49%,
    #5ee2a9 51%,
    #5ee2a9
  );
}
.sell-call {
  @apply border-ontick-orange-400 backdrop-blur-lg backdrop-filter;
  background: linear-gradient(
    to bottom left,
    #a83900,
    #a83900 49%,
    #e47529 51%,
    #e47529
  );
}
.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
}
</style>
